<template>
  <SectionContainerPage>
    <SectionClientList
      xs12
      :clientList="clientList"
      :toolbarActions="[]"
      @onAddNewClientClicked="showDialogFormClientAdd = true"
      @onEditClientClicked="
        (val) => [
          (clientToEdit = val.clientToEdit),
          (showDialogFormClientEdit = true),
        ]
      "
      :isLoading="isLoading"
      :shouldShowSearch="true"
    />
    <DialogFormClientAdd
      :showDialog="showDialogFormClientAdd"
      @onCancelClicked="showDialogFormClientAdd = false"
      @onSubmitClicked="(val) => [onDialogFormClientAddSubmit(val)]"
      :isLoading="isLoading"
    />
    <DialogFormClientEdit
      :showDialog="showDialogFormClientEdit"
      :clientToEdit="clientToEdit"
      @onCancelClicked="showDialogFormClientEdit = false"
      @onSubmitClicked="(val) => [onDialogFormClientEditSubmit(val)]"
      :isLoading="isLoading"
    />
    <DialogFormConfirmation
      :showDialog="confirmationDialogShow"
      :title="confirmationDialogTitle"
      :message="confirmationDialogMessage"
      :submitButtonText="confirmationDialogSubmitButtonText"
      :submitButtonIcon="confirmationDialogSubmitButtonIcon"
      :submitButtonColor="confirmationDialogSubmitButtonColor"
      :cancelButtonText="confirmationDialogCancelButtonText"
      :showCancelButton="confirmationDialogShowCancelButton"
      @onSubmitClicked="onConfirmationDialogSubmitClicked"
      @onCancelClicked="onConfirmationDialogCancelClicked"
      :isLoading="isLoading"
    />
  </SectionContainerPage>
</template>

<script>
import mixinAssetApi from '../../../common/mixins/mixinAssetApi'
import mixinAssetHelper from '../../../common/mixins/mixinAssetHelper'
import mixinConfirmationDialog from '../../../common/mixins/mixinConfirmationDialog'

import SectionContainerPage from '../../../common/components/layouts/SectionContainerPage'
import SectionClientList from './sections/SectionClientList'
import DialogFormClientAdd from '../dialogs/DialogFormClientAdd'
import DialogFormClientEdit from '../dialogs/DialogFormClientEdit'
import DialogFormConfirmation from '../dialogs/DialogFormConfirmation'

export default {
  components: {
    SectionContainerPage,
    SectionClientList,
    DialogFormClientAdd,
    DialogFormClientEdit,
    DialogFormConfirmation,
  },
  mixins: [mixinAssetApi, mixinAssetHelper, mixinConfirmationDialog],
  props: {},
  data: () => ({
    showDialogFormClientAdd: false,
    showDialogFormClientEdit: false,
    clientList: [],
    clientToEdit: {},
    isLoadingCount: 0,
  }),
  activated() {
    this.fetchLists()
  },
  computed: {
    isLoading() {
      return this.isLoadingCount > 0
    },
  },
  watch: {
    isLoading() {
      this.$emit('isLoadingChange', this.isLoading)
    },
  },
  methods: {
    onDialogFormClientAddSubmit(data) {
      this.isLoadingCount++
      this._insertClient({
        name: data.name,
        successCb: () => {
          this.isLoadingCount--
          this.showDialogFormClientAdd = false
          this.fetchLists()
          this.$emit('notify', { message: 'Client successfully created!' })
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
    onDialogFormClientEditSubmit(data) {
      this.isLoadingCount++
      this._updateClient({
        id: data.id,
        name: data.name,
        isEnabled: data.isEnabled,
        successCb: () => {
          this.isLoadingCount--
          this.showDialogFormClientEdit = false
          this.fetchLists()
          this.$emit('notify', { message: 'Client successfully updated!' })
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
    fetchLists() {
      this.isLoadingCount++
      this._fetch({
        types: ['Client'],
        successCb: (data) => {
          this.isLoadingCount--
          this.clientList = data.clients
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.clientList = []
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
  },
}
</script>
